import React, { ReactNode } from "react";
import styled from "styled-components";

const sizes = {
  sm: 1,
  md: 2,
  lg: 3,
};

const itemsAlignments = {
  flexStart: "flex-start",
  flexEnd: "flex-end",
  center: "center",
};

const selfAlignments = {
  flexStart: "flex-start",
  flexEnd: "flex-end",
  center: "center",
  auto: "auto",
};

const justifications = {
  flexStart: "flex-start",
  center: "center",
  flexEnd: "flex-end",
  spaceBetween: "space-between",
  spaceEvenly: "space-evenly",
};

const directions = {
  row: "row",
  column: "column",
};

export type FlexBoxSize = keyof typeof sizes;
type AlignItems = keyof typeof itemsAlignments;
type AlignSelf = keyof typeof selfAlignments;
type Justify = keyof typeof justifications;
type Direction = keyof typeof directions;

interface FlexBoxProps {
  size?: FlexBoxSize;
  alignItems?: AlignItems;
  alignSelf?: AlignSelf;
  justify?: Justify;
  flexDirection?: Direction;
  children: ReactNode;
  className?: string;
  gap?: string;
}

const FlexBox: React.FC<FlexBoxProps> = ({
  children,
  size,
  alignItems = "flexStart",
  alignSelf = "auto",
  justify = "center",
  flexDirection = "row",
  className,
  gap,
}) => {
  return (
    <Container
      size={size}
      alignItems={alignItems}
      alignSelf={alignSelf}
      justify={justify}
      flexDirection={flexDirection}
      className={className}
      gap={gap}
    >
      {children}
    </Container>
  );
};

interface ContainerProps {
  size?: FlexBoxSize;
  alignItems: AlignItems;
  alignSelf: AlignSelf;
  justify: Justify;
  flexDirection: Direction;
  gap?: string;
}

const Container = styled.div<ContainerProps>`
  display: flex;
  align-self: stretch;
  ${({ size }) => (size ? `flex: ${sizes[size]};` : "")};
  align-items: ${({ alignItems }) => itemsAlignments[alignItems]};
  align-self: ${({ alignSelf }) => selfAlignments[alignSelf]};
  justify-content: ${({ justify }) => justifications[justify]};
  flex-direction: ${({ flexDirection }) => flexDirection};
  gap: ${({ gap }) => gap};
`;

export default FlexBox;
